const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead
  basename: '/',
  defaultPath: '/',
  fontFamily: `'Libre Franklin', sans-serif`,
  borderRadius: 6
};

export default config;
